export const mainBannerImage = [
  { id: 0, img: '', url: '' },
  { id: 0, img: '', url: '' },
  { id: 0, img: '', url: '' },
  { id: 0, img: '', url: '' },
  { id: 0, img: '', url: '' },
  { id: 0, img: '', url: '' },
  { id: 0, img: '', url: '' },
  { id: 0, img: '', url: '' },
  { id: 0, img: '', url: '' },
  { id: 0, img: '', url: '' },
  { id: 0, img: '', url: '' },
  { id: 0, img: '', url: '' },
];

export const mainBannerProperties = {
  speed: 500,
  slidesToShow: 1,
  slidesToScroll: 1,
  infinite: true,
  indicators: true,
  arrows: true,
  dots: true,
  autoplay: true,
  autoplaySpeed: 3000,
  cssEase: 'linear',
  responsive: [
    {
      breakpoint: 768,
      settings: {
        arrows: false,
        dots: false,
      },
    },
  ],
};

export const newbookProperties = {
  speed: 500,
  slidesToShow: 5,
  slidesToScroll: 1,
  infinite: true,
  indicators: true,
  arrows: false,
  dots: false,
  autoplay: true,
  autoplaySpeed: 3000,
};

export const newbookTabletProperties = {
  speed: 500,
  slidesToShow: 3,
  slidesToScroll: 1,
  infinite: true,
  indicators: true,
  arrows: false,
  dots: false,
  autoplay: true,
  autoplaySpeed: 3000,
};

export const newbookMobileProperties = {
  speed: 500,
  slidesToShow: 2,
  slidesToScroll: 1,
  infinite: true,
  indicators: true,
  arrows: false,
  dots: false,
  autoplay: true,
  autoplaySpeed: 3000,
};

export const storeProperties = {
  speed: 500,
  slidesToShow: 5,
  slidesToScroll: 1,
  infinite: true,
  indicators: true,
  arrows: false,
  dots: false,
  autoplay: true,
  autoplaySpeed: 3000,
};

// export const bookstore = [
//   {
//     id: 1,
//     img: 'assets/images/logo/kyobo.gif',
//     url: 'http://www.kyobobook.co.kr',
//     alt: '교보문고 홈페이지 바로가기',
//   },
//   {
//     id: 2,
//     img: 'assets/images/logo/yes24.gif',
//     url: 'http://www.yes24.com/home/default.asp?SID=iuEqSs',
//     alt: 'yes24 홈페이지 바로가기',
//   },
//   {
//     id: 3,
//     url: 'http://www.interpark.com/bookPark/html/book.html',
//     img: 'assets/images/logo/interpark.gif',
//     alt: '인터파크 도서 홈페이지 바로가기',
//   },

//   {
//     id: 4,
//     url: 'http://www.aladin.co.kr/',
//     img: 'assets/images/logo/aladin.gif',
//     alt: '알라딘 홈페이지 바로가기',
//   },

//   {
//     id: 5,
//     url: 'http://duck-sung.co.kr/',
//     img: 'assets/images/logo/ducksung.gif',
//     alt: '서울덕성기술학원 홈페이지 바로가기',
//   },

//   {
//     id: 6,
//     url: 'http://www.web1978.or.kr/index.php',
//     img: 'assets/images/logo/hyundai.gif',
//     alt: '현대 CAD 디자인 직업 전문학교 홈페이지 바로가기',
//   },

//   {
//     id: 7,
//     url: 'http://www.sm6000.co.kr/index.html',
//     img: 'assets/images/logo/sungmin.gif',
//     alt: '성민열관리기술학원 홈페이지 바로가기',
//   },

//   {
//     id: 8,
//     url: 'http://www.환경에듀.com/',
//     img: 'assets/images/logo/jeon.gif',
//     alt: '전쌤의 환경에듀 홈페이지 바로가기',
//   },

//   {
//     id: 9,
//     url: 'http://www.hrdkorea.or.kr',
//     img: 'assets/images/logo/hrdkorea.gif',
//     alt: '한국산업인력공단 홈페이지 바로가기',
//   },

//   {
//     id: 10,
//     url: 'http://www.dbedu.or.kr/w/main/main.do',
//     img: 'assets/images/logo/dbedu.gif',
//     alt: '서울동부기술교육원 홈페이지 바로가기',
//   },

//   {
//     id: 11,
//     url: 'http://www.bukedu.or.kr/home/homeIndex.do',
//     img: 'assets/images/logo/bukedu.gif',
//     alt: '서울북부기술교육원 홈페이지 바로가기',
//   },
// ];

export const newBook = [
  { id: 0, url: '', img: '', alt: '', name: '', writer: '', price: '' },
  { id: 1, url: '', img: '', alt: '', name: '', writer: '', price: '' },
  { id: 2, url: '', img: '', alt: '', name: '', writer: '', price: '' },
  { id: 3, url: '', img: '', alt: '', name: '', writer: '', price: '' },
  { id: 4, url: '', img: '', alt: '', name: '', writer: '', price: '' },
  { id: 5, url: '', img: '', alt: '', name: '', writer: '', price: '' },
  { id: 6, url: '', img: '', alt: '', name: '', writer: '', price: '' },
  { id: 7, url: '', img: '', alt: '', name: '', writer: '', price: '' },
  { id: 8, url: '', img: '', alt: '', name: '', writer: '', price: '' },
  { id: 9, url: '', img: '', alt: '', name: '', writer: '', price: '' },
];

// export const mainBannerImage = [
//   { id: 1, img: 'assets/images/banner/main_03.jpg', url: 'https://cafe.naver.com/makels' },
//   { id: 2, img: 'assets/images/banner/main_02.jpg', url: '' },
//   { id: 3, img: 'assets/images/banner/main_03.jpg', url: '' },
//   { id: 4, img: 'assets/images/banner/main_04.jpg', url: '' },
//   { id: 5, img: 'assets/images/banner/main_05.jpg', url: '' },
// ];

// [
//   {
//     id: 1,
//     url: '/books/1',
//     img: 'assets/images/thumbnails/01.jpg',
//     alt: '샘플이미지',

//     name: '자동차는 인간과 더불어 진화한다',
//     writer: '자동차인간학 연구회',
//     price: '16,000원',
//   },
//   {
//     id: 2,
//     url: '/books/2',
//     img: 'assets/images/thumbnails/02.jpg',
//     alt: '샘플이미지',

//     name: '뷰티 트렌드',
//     writer: '홍수남 권오혁',
//     price: '16,000원',
//   },
//   {
//     id: 3,
//     url: '/books/3',
//     img: 'assets/images/thumbnails/01.jpg',
//     alt: '샘플이미지',

//     name: '자동차는 인간과 더불어 진화한다',
//     writer: '자동차인간학 연구회',
//     price: '16,000원',
//   },
//   {
//     id: 4,
//     url: '/books/4',
//     img: 'assets/images/thumbnails/02.jpg',
//     alt: '샘플이미지',

//     name: '뷰티 트렌드',
//     writer: '홍수남 권오혁',
//     price: '16,000원',
//   },
//   {
//     id: 5,
//     url: '/books/5',
//     img: 'assets/images/thumbnails/01.jpg',
//     alt: '샘플이미지',
//     name: '자동차는 인간과 더불어 진화한다',
//     writer: '자동차인간학 연구회',
//     price: '16,000원',
//   },
//   {
//     id: 6,
//     url: '/books/6',
//     img: 'assets/images/thumbnails/02.jpg',
//     alt: '샘플이미지',

//     name: '뷰티 트렌드',
//     writer: '홍수남 권오혁',
//     price: '16,000원',
//   },
//   {
//     id: 7,
//     url: '/books/7',
//     img: 'assets/images/thumbnails/01.jpg',
//     alt: '샘플이미지',

//     name: '자동차는 인간과 더불어 진화한다',
//     writer: '자동차인간학 연구회',
//     price: '16,000원',
//   },
//   {
//     id: 8,
//     url: '/books/8',
//     img: 'assets/images/thumbnails/02.jpg',
//     alt: '샘플이미지',

//     name: '뷰티 트렌드',
//     writer: '홍수남 권오혁',
//     price: '16,000원',
//   },
//   {
//     id: 9,
//     url: '/books/9',
//     img: 'assets/images/thumbnails/01.jpg',
//     alt: '샘플이미지',

//     name: '자동차는 인간과 더불어 진화한다',
//     writer: '자동차인간학 연구회',
//     price: '16,000원',
//   },
//   {
//     id: 10,
//     url: '/books/10',
//     img: 'assets/images/thumbnails/02.jpg',
//     alt: '샘플이미지',

//     name: '뷰티 트렌드',
//     writer: '홍수남 권오혁',
//     price: '16,000원',
//   },
// ];
